import React, { useState } from 'react';
import { Check, X, Terminal, Import } from 'lucide-react';
import './MainMatm.css';
import { BASE_URL_AEPS } from '../../../utils/Constants';
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';

export default function ThreeWayRecon() {
    const [merchantTransactionId, setMerchantTransactionId] = useState("");
    const [fingpayTransactionId, setFingpayTransactionId] = useState("");
    const [transactionRrn, setTransactionRrn] = useState("");
    const [transactionDate, setTransactionDate] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [res, setRes] = useState("00")

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [modal, setModal] = useState({ show: false, type: "", title: "", message: "" });

    const formatToCustomDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split('-');
        return `${day}-${month}-${year}`;
    };

    const validateForm = () => {
        const newErrors = {};
        if (!merchantTransactionId.trim()) newErrors.merchantTransactionId = "Merchant Txn ID is required";
        if (!fingpayTransactionId.trim()) newErrors.fingpayTransactionId = "Fingpay ID is required";
        if (!transactionRrn.trim()) newErrors.transactionRrn = "RRN number is required";
        if (!transactionDate) newErrors.transactionDate = "Selection of date is mandatory";
        if (!serviceType) newErrors.serviceType = "Please select a service type";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setMerchantTransactionId("");
        setFingpayTransactionId("");
        setTransactionRrn("");
        setTransactionDate("");
        setServiceType("");
        setErrors({});
    };




    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;
        setLoading(true);

        try {
            const myHeaders = {
                "Content-Type": "application/json",
                "Accept": "application/json"
            };

            const raw = JSON.stringify([{
                merchantTransactionId: merchantTransactionId.trim(),
                fingpayTransactionId: fingpayTransactionId.trim(),
                transactionRrn: transactionRrn.trim(),
                responseCode: res,
                transactionDate: formatToCustomDate(transactionDate),
                serviceType: serviceType,
            }]);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${BASE_URL_AEPS}${API_ENDPOINTS.THREEWAY_RECON_MATM}`,
                requestOptions
            );

            const result = await response.json();


            if (result && result.apiStatus === true) {
                setModal({
                    show: true,
                    type: "success",
                    title: "Request Completed",
                    message: "Transaction verified successfully."
                });
                resetForm();
            } else {

                setModal({
                    show: true,
                    type: "error",
                    title: "Request Failed",
                    message: result.apiStatusMessage || "Something went wrong with the verification."
                });
            }

        } catch (error) {
            setModal({
                show: true,
                type: "error",
                title: "Server Error",
                message: error.message || "Server error occurred"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="a1b2c3_la-wrapper">
            <div className="a1b2c3_la-form-card">
                <div className="a1b2c3_la-form-container">
                    <div className="a1b2c3_la-header-section">
                        <h2 className="a1b2c3_la-form-title">3-Way Recon</h2>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Merchant Transaction ID</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={merchantTransactionId}
                                    onChange={(e) => {
                                        setMerchantTransactionId(e.target.value);
                                        setErrors({ ...errors, merchantTransactionId: "" });
                                    }}
                                    className={`a1b2c3_la-input ${errors.merchantTransactionId ? 'a1b2c3_la-input-error' : ''}`}
                                    placeholder="Enter Merchant Transaction Id"
                                />
                            </div>
                            {errors.merchantTransactionId && <span className="a1b2c3_la-error-text">{errors.merchantTransactionId}</span>}
                        </div>

                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Fingpay Transaction Id</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={fingpayTransactionId}
                                    onChange={(e) => {
                                        setFingpayTransactionId(e.target.value);
                                        setErrors({ ...errors, fingpayTransactionId: "" });
                                    }}
                                    className={`a1b2c3_la-input ${errors.fingpayTransactionId ? 'a1b2c3_la-input-error' : ''}`}
                                    placeholder="Enter Fingpay Transaction Id"
                                />
                            </div>
                            {errors.fingpayTransactionId && <span className="a1b2c3_la-error-text">{errors.fingpayTransactionId}</span>}
                        </div>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Transaction RRN</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={transactionRrn}
                                    onChange={(e) => {
                                        setTransactionRrn(e.target.value);
                                        setErrors({ ...errors, transactionRrn: "" });
                                    }}
                                    className={`a1b2c3_la-input ${errors.transactionRrn ? 'a1b2c3_la-input-error' : ''}`}
                                    placeholder="Enter 12-digit RRN"
                                />
                            </div>
                            {errors.transactionRrn && <span className="a1b2c3_la-error-text">{errors.transactionRrn}</span>}
                        </div>

                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Select Date</label>
                            <div className="a1b2c3_la-date-wrapper">
                                <input
                                    type="date"
                                    value={transactionDate}
                                    onChange={(e) => {
                                        setTransactionDate(e.target.value);
                                        setErrors({ ...errors, transactionDate: "" });
                                    }}
                                    className={`a1b2c3_la-input-date ${errors.transactionDate ? 'a1b2c3_la-input-error' : ''}`}
                                />
                            </div>
                            {errors.transactionDate && <span className="a1b2c3_la-error-text">{errors.transactionDate}</span>}
                        </div>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Service Type</label>
                            <div className="a1b2c3_la-select-wrapper">
                                <select
                                    value={serviceType}
                                    onChange={(e) => {
                                        setServiceType(e.target.value);
                                        setErrors({ ...errors, serviceType: "" });
                                    }}
                                    className={`a1b2c3_la-custom-select ${errors.serviceType ? 'a1b2c3_la-input-error' : ''}`}
                                >
                                    <option value="" disabled>Choose a service...</option>
                                    <option value="MATMCW">M-ATM Cash Withdrawal</option>
                                    <option value="BE">Balance Enquiry</option>
                                </select>
                            </div>
                            {errors.serviceType && <span className="a1b2c3_la-error-text">{errors.serviceType}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group a1b2c3_mobile-hide"></div>
                    </div>

                    <div className="a1b2c3_la-actions-row">
                        <button className="a1b2c3_la-submit-btn-half" onClick={handleSubmit} disabled={loading}>
                            {loading ? <span className="loader-inline"></span> : 'Submit'}
                        </button>
                        <button className="a1b2c3_la-clear-btn-half" onClick={resetForm} disabled={loading}>
                            Clear
                        </button>
                    </div>
                </div>
            </div>


            {modal.show && (
                <div className="fa-modal-overlay">
                    <div className="fa-modal-content">
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modal.type === "success" ? '#ecfdf5' : modal.type === "error" ? '#fff1f2' : '#fffbeb',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {modal.type === "success" && <Check size={32} color="#10b981" strokeWidth={3} />}
                            {modal.type === "error" && <X size={32} color="#ef4444" strokeWidth={3} />}
                            {modal.type === "warning" && <Terminal size={32} color="#f59e0b" strokeWidth={3} />}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>{modal.title}</h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>{modal.message}</p>
                        <button
                            className="la-submit-btn-half"
                            style={{ background: modal.type === "success" ? '#10b981' : modal.type === 'error' ? '#ef4444' : '#f59e0b' }}
                            onClick={() => setModal({ ...modal, show: false })}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
